import(/* webpackMode: "eager" */ "/vercel/path0/src/app/tr/blog/hamilelikte-dolgu-bilimsel-veriler-riskler-ve-uzman-yaklasimi/page.tsx");
